// fieldLabels maps error attribute keys (database column names) to the labels the form shows the
// user, so surfaced messages read "Highlights: ..." rather than "most_proud_of: ...". Unmapped keys
// fall back to the raw attribute name.
export const errorMessage = (error, fieldLabels = {}) => {
  const data = error.response?.data;
  let message = data?.errors || data?.error || data?.message || error.response?.statusText;
  if (message && typeof message === 'object') {
    message = Object.entries(message)
      .map(([k, v]) => {
        const reason = Array.isArray(v) ? v.join(' ') : v;
        return `${fieldLabels[k] ?? k}: ${reason}`;
      })
      .join('\n');
  }
  return data ? message : `${error.status} ${message}`;
};

export const textError = (errors) => {
  if (!errors) return null;
  return Array.isArray(errors) ? errors.join(' ') : errors;
};

// A form only renders the error keys it has fields for, so a 422 naming any other attribute lands
// in state and is never shown: the form just stays open as though the Save did nothing (#8533 --
// an initiative whose duplicate `position` made every edit fail silently; a stale `lock_version`
// does the same). Pass the keys the form renders itself; what comes back is the rest, as one
// string, or null when every error is already on screen.
const humanizedAttribute = (key) =>
  key
    .replace(/_id$/, '')
    .replace(/_/g, ' ')
    .replace(/^./, (character) => character.toUpperCase());

export const unhandledErrorText = (errors, handledKeys = []) => {
  const messages = Object.entries(errors || {})
    .filter(([key]) => !handledKeys.includes(key))
    .map(([key, value]) => {
      const message = textError(value);
      if (!message) return null;
      // Rails messages on these forms are written as whole sentences that already name the field
      // ("Position must be unique to initiatives..."); only the bare ones need the attribute.
      const label = humanizedAttribute(key);
      return message.toLowerCase().startsWith(label.toLowerCase()) ? message : `${label} ${message}`;
    })
    .filter(Boolean);

  return messages.length > 0 ? messages.join(' ') : null;
};
